import { render } from "./AddRegistration.vue?vue&type=template&id=3eefd70b&scoped=true"
import script from "./AddRegistration.vue?vue&type=script&lang=js"
export * from "./AddRegistration.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AddRegistration.vue?vue&type=style&index=1&id=3eefd70b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eefd70b"]])

export default __exports__